import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window | null>('Window object', {
    providedIn: 'root',
    factory: () => inject(DOCUMENT).defaultView,
});
